// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"345":"4def4fc6","394":"220315ff","469":"40763926","475":"be5c2f5e","721":"a129be78"}[chunkId] + ".chunk.css";
};